export default {
    headline: 'SIEGENIA Mediacenter',
    search_info: 'Wonach suchen Sie?',
    back: 'zurück',
    no_results: 'Keine Ergebnisse gefunden. Bitte überprüfen Sie die Suchanfrage',
    service: {
        downloads: 'Dokumente',
        videos: 'Videos',
        faq: 'FAQ'
    },
    service_search: {
        category_placeholder: "Nach Kategorie Filtern"
  },
  service_download: {
    select_info: 'Bitte wählen Sie Ihren Suchbereich',
    select_productgroup: 'Produktbereich auswählen',
    select_product: 'Produkt auswählen',
    select_type: 'Medien filtern',
    option_language: "Sprache",

        types: {
            tec_info: 'Technische Informationen',
            installation: 'Montageanleitungen',
            planning: 'Planungsunterlagen',
            catalog: 'Prospekt',
            order_forms: 'Bestellformulare',
            maintenance: 'Wartungsanleitungen',
            construction_drawings: 'Konstruktions Zeichnungen',
            software: 'Software',
            certificate: 'Zertifikate & Richtlinien',
            press: 'Presse & Marketingunterlagen',
            videos: 'Videos',
            undefined: 'Sonstiges',
            commercial: 'Werbespot',
            product_video: 'Produktfilm',
            operating: 'Bedienung',
            'function': 'Funktion',
            'assembly': 'Anschlag',
            'assembly_instructions': 'Anschlaganleitungen',
            'installation_video': 'Einbau / Montage',
            'brochure': 'Prospekte',
            'tec_catalog': 'Technische Kataloge',
            'tec_sheet': 'Technische Datenblätter',
            'usage_charts': 'Anwendungsdiagramme',
            'profile_sheet': 'Profil-Datenblätter',
            'operations_manual': 'Bedienungs- und Pflegeanleitungen',
            hardware_info: 'Beschlaginformation',
            'installation_suggestion': 'Montagevorschlag',
            'general': 'Allgemein',
            'troubleshooting': 'Fehlerbehebung',
            "smarthome:general": 'Allgemein',
            'smarthome:installation': 'Installation',
            'smarthome:troubleshooting': 'Fehlerbehebung',
            'smarthome:startup': 'Inbetriebnahme',
            'smarthome:operating': 'Bedienung',
            'order': 'Bestellung',
        },
        filter_sorting: {
            filter: "Filter",
            sorting: "Sortieren",
            asc: "Titel aufsteigend (A-Z)",
            desc: "Titel absteigend (Z-A)",
            date_asc: "Datum älteste zuerst",
            date_desc: "Datum neuste zuerst",
            relevance: "Relevanz",
            facet_headline: "Suchergebnisse Filtern",
            facet_filter_lang: "Sprachen",
            facet_filter_type_id: "Typ",
            facet_filter_level_0: "Kategorie",
            category_headline: "Kategorie",
      filter_remove: "Filter zurücksetzen",
      show_hide: "Filter anzeigen",

        },
        result: {
            count_media: "Medien",
            show_results: "Anzeigen",
            preview_type_catalog: "HTML",
            lang_not_available: "Aktuell nicht verfügbar in Ihrer Sprache",
            version_info: "Dieser Link führt zur neuesten Version der Dokumentation. Wenn Sie eine ältere Version benötigen, dann nehmen Sie Kontakt mit Ihrem SIEGENIA Kundenbetreuer auf."
        }
    },
    service_faq: {
        types: {}
    },
    countries: {
        global: "Global",
        en: "Global",
        ch: "Schweiz",
        it: "Italien",
        pl: "Polen",
        es: "Spanien",
        cn: "China",
        gb: "Großbritannien",
        de: "Deutschland",
        at: "Österreich",
        fr: "Frankreich",
        nl: "Niederlande",
        ru: "Russland",
        cz: "Tschechien",
        in: "Indien",
        ba: "Bosnien"
    },
    languages: {
        de: "Deutsch",
        en: "Englisch",
        bs: "Bosnisch",
    }
};
